const { STRING } = require('../primitives');

const string = {
  ...STRING,
};
module.exports = string;
